/* eslint-disable prettier/prettier */
import { ChevronDown, ChevronUp, Edit } from 'lucide-react';
import { useState, ReactNode } from 'react';

interface Props {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  isCedant?: boolean;
  onEdit?: () => void;
  onCancel?: () => void;
  isEditing?: boolean;
  extraAction?: React.ReactNode;
}

export const CollapsibleSection = ({
  title,
  icon,
  children,
  isCedant,
  onEdit,
  onCancel,
  isEditing,
  extraAction,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onEdit) onEdit();
  };

  return (
    <div className="mb-3 bg-white border rounded-lg">
      <button
        onClick={() => {
          if (isOpen) {
            if (onCancel) {
              onCancel();
            }
          }
          setIsOpen(!isOpen);
        }}
        className="flex items-center justify-between w-full p-4 font-semibold text-left text-primary"
      >
        <div className="flex items-center gap-2">
          {icon && <div>{icon}</div>}
          {title}
        </div>
        <div className="flex items-center gap-2">
          {extraAction && isOpen && extraAction}
          {isCedant && isOpen && !isEditing && (
            <Edit className="cursor-pointer text-primary" size={16} onClick={handleEditClick} />
          )}
          {isOpen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </div>
      </button>
      {isOpen && <div className="px-4 pb-4 text-sm text-muted-foreground">{children}</div>}
    </div>
  );
};
